import React, { useState, useMemo } from 'react';
import classnames from 'classnames';
import Select from 'scy/Select';
import { Body, Paragraph } from 'scy/text';
import { PrimaryButton, AltSecondaryButton } from 'scy/buttons';
import { hidden, tablet_flex, tablet_hidden } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import styles from './styles.mod.scss';

const noop = () => null;

export default function QtySelector({
  className,
  buttonText,
  buttonAction,
  selectorDisabled,
  buttonDisabled,
  defaultQty = 1,
  minQty = 1,
  maxQty = 10
}) {
  const range = useMemo(
    () =>
      Array(maxQty)
        .fill()
        .map((_, i) => ({ value: i + 1 })),
    [maxQty]
  );

  const [value, setValue] = useState(defaultQty);
  const decrease = () => value > minQty && setValue(value => value - 1);
  const increase = () => value < maxQty && setValue(value => value + 1);
  const select = value => setValue(value);
  const handleClick = () => buttonAction(value);

  return (
    <>
      <div className={classnames(hidden, tablet_flex, className)}>
        <Select
          instanceId="product-qty"
          className={styles.select}
          clearable={false}
          searchable={false}
          options={range}
          optionRenderer={item => item.value}
          value={{ value }}
          valueRenderer={({ value }) => (
            <Body
              tag="span"
              className={selectorDisabled ? styles.disabledText : null}
            >
              {value}
            </Body>
          )}
          onChange={({ value }) => select(value)}
          onSuggestionsFetchRequested={noop}
          onSuggestionsClearRequested={noop}
          disabled={selectorDisabled}
          scrollMenuIntoView={false}
          smallArrow
        />
        <PrimaryButton
          onClick={handleClick}
          disabled={buttonDisabled}
          className={styles.selectBtn}
        >
          {buttonText}
        </PrimaryButton>
      </div>

      {buttonDisabled ? null : (
        <div className={tablet_hidden}>
          <MobileAddToCart
            selectorDisabled={selectorDisabled}
            buttonAction={handleClick}
            buttonText={buttonText}
            decrease={decrease}
            increase={increase}
            qty={value}
          />
        </div>
      )}
    </>
  );
}

const MobileAddToCart = ({
  selectorDisabled,
  buttonAction,
  buttonText,
  decrease,
  increase,
  qty
}) => (
  <div className={styles.mobileContainer}>
    {selectorDisabled ? null : (
      <div className={flex}>
        <AltSecondaryButton
          noBorder
          onClick={decrease}
          className={styles.mobileQtyBtn}
        >
          -
        </AltSecondaryButton>
        <Paragraph tag="span" className={styles.mobileQtyNumber}>
          {qty}
        </Paragraph>
        <AltSecondaryButton
          noBorder
          onClick={increase}
          className={styles.mobileQtyBtn}
        >
          +
        </AltSecondaryButton>
      </div>
    )}
    <PrimaryButton
      onClick={buttonAction}
      className={`${flex1} ${margin.top_sm} ${margin.bottom_sm} ${
        margin.left_xs
      } ${margin.right_sm}`}
    >
      {buttonText}
    </PrimaryButton>
  </div>
);
